import _ from "lodash";
import { useMemo } from "react";
import { Order, OrderItemsEntity } from "./constants/types";

export default function getImportantProductFromOrder(order?: Order) {
  return order?.order_items.sort((item: OrderItemsEntity) => item?.price)[0];
}

type directions = "ASC" | "DESC";
export function sortOrderItemsByPrice(
  orderItems: Order["order_items"],
  direction: directions = "DESC"
) {
  return orderItems.sort((a, b) => {
    const returnVal =
      direction === "DESC" ? b.price - a.price : a.price - b.price;

    if (returnVal === 0) {
      // fallback sorting if prices are the same, sort by name
      return direction === "DESC"
        ? b.name.localeCompare(a.name)
        : a.name.localeCompare(b.name);
    }

    return returnVal;
  });
}

function useSortedOrderItems(orderItems: Order["order_items"]) {
  return useMemo(() => {
    if (orderItems.length === 0) return [];
    return sortOrderItemsByPrice(orderItems);
  }, [orderItems]);
}
